import React from 'react';
import { useTranslation } from 'react-i18next';
import { MenuItem, MenuProps } from '../../../components/MenuItem';
import advcashIcon from './static/img/advcash.svg';

export const Menu = (props: MenuProps) => {
  const { t } = useTranslation('byAdvCash');

  return (
    <MenuItem
      {...props}
      icon={advcashIcon}
      name={t('Advcash')}
      description={t('USD, from wallet')}
    />
  );
};
